import { render, staticRenderFns } from "./Box5.vue?vue&type=template&id=12123032&scoped=true&"
import script from "./Box5.vue?vue&type=script&lang=js&"
export * from "./Box5.vue?vue&type=script&lang=js&"
import style0 from "./Box5.vue?vue&type=style&index=0&id=12123032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12123032",
  null
  
)

export default component.exports